
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function GovernanceSection() {
  const { t } = useTranslation('method');
  const { ref: leftRef, isVisible: leftVisible } = useScrollReveal({ threshold: 0.15 });
  const { ref: rightRef, isVisible: rightVisible } = useScrollReveal({ threshold: 0.1 });

  const items = t('governance.items', { returnObjects: true }) as Array<{
    icon: string;
    title: string;
    text: string;
  }>;

  return (
    <section className="py-28 px-6 bg-[#F6F2EC]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-20 items-start">
          {/* Left */}
          <div ref={leftRef}>
            <p
              className="text-xs font-semibold tracking-[0.25em] uppercase text-[#F97700] mb-5 transition-all duration-700"
              style={{
                opacity: leftVisible ? 1 : 0,
                transform: leftVisible ? 'translateY(0)' : 'translateY(20px)',
                transitionDelay: '0ms',
              }}
            >
              {t('governance.label')}
            </p>
            <h2
              className="text-4xl md:text-5xl font-semibold text-[#0B0B0B] leading-[1.1] mb-8 tracking-tight transition-all duration-700"
              style={{
                opacity: leftVisible ? 1 : 0,
                transform: leftVisible ? 'translateY(0)' : 'translateY(24px)',
                transitionDelay: '120ms',
              }}
            >
              {t('governance.title')}
            </h2>
            <p
              className="text-base text-[#2E2E2E] leading-relaxed mb-6 transition-all duration-700"
              style={{
                opacity: leftVisible ? 1 : 0,
                transform: leftVisible ? 'translateY(0)' : 'translateY(20px)',
                transitionDelay: '220ms',
              }}
            >
              {t('governance.paragraph1')}
            </p>
            <p
              className="text-sm text-[#2E2E2E]/70 leading-relaxed border-l-2 border-[#F97700] pl-5 italic transition-all duration-700"
              style={{
                opacity: leftVisible ? 1 : 0,
                transform: leftVisible ? 'translateY(0)' : 'translateY(20px)',
                transitionDelay: '320ms',
              }}
            >
              {t('governance.disclaimer')}
            </p>
          </div>

          {/* Right */}
          <div ref={rightRef} className="grid grid-cols-1 gap-5">
            {items.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-5 bg-[#FBF8F3] border border-[#E7E1D9] p-6 transition-all duration-500"
                style={{
                  opacity: rightVisible ? 1 : 0,
                  transform: rightVisible ? 'translateX(0)' : 'translateX(32px)',
                  transitionDelay: `${i * 120}ms`,
                }}
              >
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 text-[#F97700]">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-[#0B0B0B] mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#2E2E2E]/75 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
